export default __webpack_public_path__ + "static/Carayon-fe139bd9b944147ce07bcee1daa16604.svg";